import React, { Component, PropTypes } from 'react';
import axios from 'axios';
import { Col, ControlLabel, FormGroup } from 'react-bootstrap';
import config from '../../../../config/config';

const appUrlPath = `/${config.appUrlPath}`;

class CaseStatus extends Component {
  constructor(props) {
    super(props);
    this.state = {
      option: []
    }
  }

  componentWillMount() {
    axios.get(`${appUrlPath}/getCaseStatus`, {
      params: {}
    })
    .then((res) => {
      this.setState({ option: res.data });
    })
    .catch(() => {
    });
  }

  render() {
    return (
      <FormGroup controlId="caseStatus">
        <Col componentClass={ControlLabel} sm={4}>
          Case Status
        </Col>
        <Col sm={8}>
          <select
            className="custom-select"
            onChange={this.props.handleChangeCaseStatus}
            value={this.props.caseStatus}
            id="caseStatus"
          >
            <option value="">Please Select</option>
            {this.state.option.map((obj, index) => {
              const counter = index;
              return (
                <option
                  value={obj.code}
                  key={counter}
                >{obj.name}</option>
              );
            })}
          </select>
        </Col>
      </FormGroup>
    )
  }
}

CaseStatus.propTypes = {
  handleChangeCaseStatus: PropTypes.func,
  caseStatus: PropTypes.string
};

export default CaseStatus;



// WEBPACK FOOTER //
// ./src/app/components/retrieveQuotationComponent/caseStatus/CaseStatus.js